const icon = require('vue-svgicon');
icon.register({
    'star-empty': {
        width: 30,
        height: 30,
        viewBox: '0 0 30 30',
        data: `<path d="M28.83,10.39l-8.71-1.33L16.22.8c-.5-1.06-1.95-1.06-2.45,0l-3.9,8.26-8.71,1.33c-1.12.17-1.56,1.61-.75,2.43l6.3,6.43-1.49,9.08c-.19,1.17.98,2.05,1.98,1.5l7.79-4.29,7.79,4.29c1,.55,2.17-.34,1.98-1.5l-1.49-9.08,6.3-6.43c.81-.83.36-2.26-.75-2.43ZM24.72,13.55l-4.2,4.28.99,6.05c.13.78-.65,1.37-1.32,1l-5.19-2.86-5.19,2.86c-.67.37-1.45-.23-1.32-1l.99-6.05-4.2-4.28c-.54-.55-.24-1.51.5-1.62l5.81-.89,2.6-5.51c.33-.71,1.3-.71,1.63,0l2.6,5.51,5.81.89c.75.11,1.04,1.07.5,1.62Z" _fill="#000"/>`,
    },
});
